import { ListItemText, styled } from '@mui/material';

import { formatDisplayDate } from '@app-velocity/common';

import { TPrototypeShortDto } from '@app-velocity/av-api-v2';
import { FileIcon, PrototypesIcon } from '@app-velocity/icons';
import { Typography } from '@app-velocity/ui';

export type ScenarioListItemTextProps = {
  scenario: TPrototypeShortDto;
};

const StyledData = styled('div')<{ main?: boolean }>(({ main, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  gap: theme.spacing(1),
  fontWeight: main ? 600 : 400,
  color: 'var(--text-text-primary-color)',
}));

const StyledScenarioPrompt = styled('p')({
  margin: 0,
  whiteSpace: 'nowrap',
  fontStyle: 'italic',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
});

const StyledIconContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 auto',
  svg: {
    flex: 1,
    fill: 'var(--text-text-primary-color)',
  },
});

const StyledText = styled('span')({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
});

export const ScenarioListItemText = ({
  scenario,
}: ScenarioListItemTextProps) => {
  const { pageName, name, introMessage } = scenario;

  return (
    <ListItemText
      primary={
        <>
          {scenario.created ? (
            <Typography>{formatDisplayDate(scenario.created)}</Typography>
          ) : null}
          {pageName ? (
            <StyledData main>
              <StyledIconContainer>
                <FileIcon />
              </StyledIconContainer>
              <StyledText>{pageName}</StyledText>
            </StyledData>
          ) : (
            <StyledData main>
              <StyledIconContainer>
                <PrototypesIcon />
              </StyledIconContainer>
              <StyledText>{name}</StyledText>
            </StyledData>
          )}
        </>
      }
      secondary={
        <div>
          {pageName ? (
            <StyledData>
              <StyledIconContainer>
                <PrototypesIcon />
              </StyledIconContainer>
              <StyledText>{name}</StyledText>
            </StyledData>
          ) : null}
          <StyledScenarioPrompt>{introMessage}</StyledScenarioPrompt>
        </div>
      }
    />
  );
};
